/* eslint-disable import/no-extraneous-dependencies */
import { ReactNode } from 'react';
import { Provider } from 'react-redux';
import { BrowserRouter as Router } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';

import { Notification } from '@components';

import { store } from '../core/store';
import ErrorBoundary from './ErrorBoundary';

type AppProviderProps = {
  children: ReactNode;
};

const AppProvider = ({ children }: AppProviderProps) => (
  <Provider store={store}>
    <HelmetProvider>
      <Notification />
      <Router>
        <ErrorBoundary>{children}</ErrorBoundary>
      </Router>
    </HelmetProvider>
  </Provider>
);

export default AppProvider;
